<a [routerLink]="['/']"> <img src="assets/images/logo.png" width="224" height="34" alt=""> </a>
